import { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { Command } from 'cmdk';

import { cn } from 'styles';

type CommandMenuProviderProps = ComponentPropsWithoutRef<typeof Command>;

export const CommandMenuProvider = forwardRef<ElementRef<typeof Command>, CommandMenuProviderProps>(
  ({ className, ...props }, ref) => (
    <Command
      ref={ref}
      className={cn(
        'flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground',
        className,
      )}
      {...props}
    />
  ),
);

CommandMenuProvider.displayName = Command.displayName;
